import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/core/ajax.service";
import * as i2 from "Angular/services/core/urls.service";
export class MetricsetModalService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    get() {
        const requestUrl = this.urlsService.getUrl(this.urlsService.CALCULATIONS.METRIC_SET_COLLECTION);
        return this.ajaxService.getDataObserveBody(requestUrl);
    }
    post(urlParams, postParams) {
        const requestUrl = this.urlsService.getUrl(this.urlsService.CALCULATIONS.METRIC_SET_COLLECTION, urlParams);
        return this.ajaxService.postJsonDataObserveBody(requestUrl, postParams);
    }
    put(urlParams, putParams) {
        const requestUrl = this.urlsService.getUrl(this.urlsService.CALCULATIONS.METRIC_SET, urlParams);
        return this.ajaxService.putDataObserveBody(requestUrl, putParams);
    }
    delete(urlParams) {
        const requestUrl = this.urlsService.getUrl(this.urlsService.CALCULATIONS.METRIC_SET, urlParams);
        return this.ajaxService.deleteDataObserveBody(requestUrl);
    }
}
MetricsetModalService.ɵfac = function MetricsetModalService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MetricsetModalService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
MetricsetModalService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MetricsetModalService, factory: MetricsetModalService.ɵfac, providedIn: 'root' });
